// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dC-z","response":"eC-z","error":"fC-z","disabled":"gC-z","buttons":"hC-z","feedbackQuestionSection":"iC-z","yesNoWrapper":"jC-z"};